import DateFnsUtils from '@date-io/date-fns';
import format from 'date-fns/format';

/**
 * DateFnsUtilsのカスタマイズクラス
 */
export default class LocalizedUtils extends DateFnsUtils {
	public getCalendarHeaderText(date: Date): string {
		return this.format(date, 'yyyy/MM');
	}

	public getDatePickerHeaderText(date: Date): string {
		return format(date, 'MMMd, ccc', { locale: this.locale });
	}

	public getDateTimePickerHeaderText(date: Date): string {
		return this.format(date, 'MM/dd');
	}
}



// WEBPACK FOOTER //
// ./src/utils/LocatizedUtils.ts